import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import { useCart } from '../contexts/CartContext';
import Logo from './Logo';
import NotificationBell from './NotificationBell';

const Navbar = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const { isDarkMode, toggleTheme } = useTheme();
  const { itemCount } = useCart();

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <nav className="navbar">
      <div className="navbar-top">
        <div className="navbar-top-content">
          <div className="navbar-top-links">
            {user && <Link to="/order" className="navbar-top-link">Nouvelle Commande</Link>}
            {user && <Link to="/dashboard" className="navbar-top-link">Mes Commandes</Link>}
            {user && <Link to="/support" className="navbar-top-link">Support</Link>}
            <Link to="/help" className="navbar-top-link">Centre d'aide</Link>
            <Link to="/shop" className="navbar-top-link">Boutique locale</Link>
            {itemCount > 0 && (
              <Link to="/cart" className="navbar-top-link">
                Panier ({itemCount})
              </Link>
            )}
          </div>
          <div className="navbar-top-links">
            {user ? (
              <>
                <span className="navbar-top-link" style={{ color: '#666' }}>
                  {user.firstName} {user.lastName}
                </span>
                <span style={{ color: '#ccc' }}>|</span>
                <NotificationBell />
                    <span style={{ color: '#ccc' }}>|</span>
                    <Link to="/profile" className="navbar-top-link">Mon Compte</Link>
                    <span style={{ color: '#ccc' }}>|</span>
                    <button
                      onClick={toggleTheme}
                      className="navbar-top-link"
                      style={{ 
                        background: 'none', 
                        border: 'none', 
                        cursor: 'pointer', 
                        padding: '0 10px',
                        fontSize: '20px',
                        display: 'flex',
                        alignItems: 'center'
                      }}
                      title={isDarkMode ? 'Mode clair' : 'Mode sombre'}
                    >
                      {isDarkMode ? '☀️' : '🌙'}
                    </button>
                    <span style={{ color: '#ccc' }}>|</span>
                    <button
                      onClick={handleLogout}
                      className="navbar-top-link"
                      style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
                    >
                      Déconnexion
                    </button>
              </>
            ) : (
              <>
                <button
                  onClick={toggleTheme}
                  className="navbar-top-link"
                  style={{ 
                    background: 'none', 
                    border: 'none', 
                    cursor: 'pointer', 
                    padding: '0 10px',
                    fontSize: '20px',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                  title={isDarkMode ? 'Mode clair' : 'Mode sombre'}
                >
                  {isDarkMode ? '☀️' : '🌙'}
                </button>
                <span style={{ color: '#ccc' }}>|</span>
                <Link to="/login" className="navbar-top-link">Connexion</Link>
                <span style={{ color: '#ccc' }}>|</span>
                <Link to="/register" className="navbar-top-link">Inscription</Link>
              </>
            )}
          </div>
        </div>
      </div>
      <div className="navbar-content">
        <Logo linkTo="/" height="65px" />
        <div className="navbar-links">
          <Link to="/" className="navbar-link">Accueil</Link>
          <Link to="/shop" className="navbar-link">Boutique locale</Link>
          {user && <Link to="/order" className="navbar-link">Commande internationale</Link>}
          {user && <Link to="/dashboard" className="navbar-link">Mes Commandes</Link>}
          {user && <Link to="/support" className="navbar-link">Support</Link>}
          <Link to="/help" className="navbar-link">Centre d'aide</Link>
          {user && (user.role === 'agent' || user.role === 'admin') && (
            <>
              <Link to="/agent" className="navbar-link">Dashboard Agent</Link>
              <Link to="/admin/products" className="navbar-link">Catalogue</Link>
            </>
          )}
          {user && user.role === 'admin' && (
            <Link to="/admin" className="navbar-link">Dashboard Admin</Link>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;

